<template>
  <div id="jointOrderAList">
    <!-- <van-nav-bar title="客户管理" fixed placeholder left-text="返回" left-arrow>
            <a @click="$router.back()" slot="left">
                <i class="iconfont iconfanhuianniu"></i>
            </a>
            <a @click="$router.push({path:'/customerAdd'})" slot="right">
                <i class="iconfont icontianjia"></i>
            </a>
        </van-nav-bar> -->
    <van-tabs v-model="active" @change="changeActive" scrollspy>
      <van-tab title="我的客户"></van-tab>
      <van-tab title="公共客户"></van-tab>
    </van-tabs>
    <div class="search">
      <div class="status" @click="popupVisible = true">
        {{ statusObj.label }}
        <span v-if="statusObj.labelOld">-</span>
        {{ statusObj.labelOld }}
        <!-- <span v-if="!statusObj.label">全部状态</span> -->
        <i class="iconfont iconxiala"></i>
      </div>
      <div class="searchbar">
        <i class="iconfont iconSearch left"></i>
        <form action="javascript:return true;">
          <input
            v-model="listQuery.basicInfo"
            placeholder="姓名/手机"
            type="search"
            @keypress="searchBtn"
            maxlength="11"
          />
        </form>
        <i
          v-if="listQuery.basicInfo"
          @click="resetQuery"
          class="iconfont iconclose right"
        ></i>
      </div>
    </div>
    <div class="fixedH">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        offset="50"
        @load="onLoad"
      >
        <div class="body">
          <div
            class="card"
            v-for="(item, index) in list"
            :key="index"
            @click="
              $router.push({
                path: '/jointOrderADetail',
                query: { id: item.id },
              })
            "
          >
            <p>
              <span
                >{{ item.name }}&emsp;{{
                  item.gender == "1" ? "男" : item.gender == "0" ? "女" : ""
                }}
                <span class="phone" v-if="active == '0'"
                  >|
                  {{ item.phone }}
                </span>
              </span>

              <span>{{ item.statusName }}</span>
            </p>
            <p class="address">
              <span >{{ item.cityName }} |</span>
              <span >{{ item.areaName }} |</span>
              <span style="flex:1;overflow: hidden;
text-overflow:ellipsis;
white-space: nowrap">{{ item.address }}</span>
            </p>
           
            <p>
              <span>{{ item.createDate }}</span>

              <span class="go" v-if="active == '1' && $store.state.buttonAuth.indexOf('crm_jointOrderGrap') > -1 && !item.ownerId  && !(item.status == 108 || item.status == 107 || item.status == 106)">
                <van-button type="primary" size="mini" @click.stop="grap(item)"
                  >抢单</van-button
                >
              </span>
            </p>
            <p v-if="item.remark">{{ item.remark }}</p>
          </div>
        </div>
      </van-list>
    </div>
    <!-- <div class="add" @click="$router.push({path:'/customerAdd'})">
            <i class="iconfont icontianjia"></i>
        </div> -->
    <div style="height: 1.2rem"></div>
    <div class="btn">
      <van-button
        block
        type="primary"
        @click="$router.push({ path: '/jointOrderAAdd' })"
        >新增</van-button
      >
    </div>
    <van-popup v-model="popupVisible" position="bottom" class="popup">
      <van-picker
        show-toolbar
        :columns="trackRecordList"
        value-key="desc"
        @cancel="popupVisible = false"
        @confirm="changeStatus"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  // requestCustomerPri,//私有客户
  // requestCustomerPub,//公共客户
  // requestAllStatus,//所有跟踪状态
  requestJointOrderCustomerPri,
  requestJointOrderCustomerPub,
  requestJointOrderCustomerGrap, //抢单
  requestjointOrderAllStatus,
  requestJointOrderGrabbing,
  // requestCustomerStatus,
} from "@/api";
import { mapState } from "vuex";
import { accSub } from "@/utils";
export default {
  name: "jointOrderAList",
  data() {
    return {
      listQuery: {
        status: "",
        basicInfo: "",
        pageSize: 10,
        pageNumber: 1,
      },
      loading: false,
      finished: false,
      statusObj: {
        label: "全部状态",
        value: "",
        labelOld: "",
        valueOld: "",
      },
      active1: "0",
      active: "0",
      popupVisible: false,
      list: [],
      trackRecordList: [], //跟踪记录状态
    };
  },
  computed: {
    ...mapState([
      "idTypeList",
      "destineList",
      "payList",
      "contractList",
      "customerList",
    ]),
  },
  activated() {
    console.log("test");
    this.listQuery.pageNumber = 1;
    this.finished = false;
    this.list = [];
    this.getList();
  },
  created() {
    this.active = this.$route.query.type || 0;
    // this.getCustomerPri();
    this.getTrackRecord();
  },
  mounted() {},
  methods: {
    //跟踪记录状态
    getTrackRecord() {
      requestjointOrderAllStatus().then((res) => {
        res.data.unshift({
          code: "",
          desc: "全部状态",
          children: null,
        });
        res.data.forEach((e) => {
          if (!e.children) {
            e.children = [{ desc: "", code: "", children: "" }];
          }
          if (e.code == 109) {
            e.children.unshift({
              code: "",
              desc: "-",
              children: null,
            });
          }
        });
        this.trackRecordList = res.data;
      });
    },
    //个人
    getCustomerPri() {
      this.loading = true;
      requestJointOrderCustomerPri(this.listQuery)
        .then((res) => {
          if (this.active == "1") return;
          this.list = [...this.list, ...res.data.records];
          let prePage = accSub(res.data.pages, 1);
          this.loading = false;
          this.listQuery.pageNumber++;
          if (
            (res.data.pages == res.data.current &&
              res.data.records.length ==
                accSub(res.data.total, prePage * 10)) ||
            !res.data.records.length
          ) {
            this.finished = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.finished = true;
        });
    },
    //公共
    getCustomerPub() {
      this.loading = true;
      requestJointOrderCustomerPub(this.listQuery)
        .then((res) => {
          if (this.active == "0") return;
          if (res.data) {
            this.list = [...this.list, ...res.data.records];
            let prePage = accSub(res.data.pages, 1);
            this.loading = false;
            this.listQuery.pageNumber++;
            if (
              (res.data.pages == res.data.current &&
                res.data.records.length ==
                  accSub(res.data.total, prePage * 10)) ||
              !res.data.records.length
            ) {
              this.finished = true;
            }
          } else {
            this.loading = false;
            this.finished = true;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getList() {
      this.active == 0 ? this.getCustomerPri() : this.getCustomerPub();
    },
    //点击搜索
    searchBtn() {
      this.listQuery.pageNumber = 1;
      this.list = [];
      if (event.keyCode == 13) {
        event.preventDefault(); //禁止默认事件（默认是换行）
        if (
          this.listQuery.basicInfo == "" ||
          this.listQuery.basicInfo == null
        ) {
          this.getList();
        } else {
          this.getList();
        }
      }
    },
    //切换状态
    changeStatus(val, index) {
      console.log(val);
      console.log(index);
      this.listQuery.pageNumber = 1;
      this.list = [];
      this.statusObj.label = val[0];
      this.statusObj.labelOld = val[1];
      this.statusObj.value = this.trackRecordList[index[0]].code;
      this.statusObj.valueOld = this.trackRecordList[index[0]].children[
        index[1]
      ].code;
      this.popupVisible = false;
      this.listQuery.status = this.statusObj.value;
      this.listQuery.lastStatus = this.statusObj.valueOld;
      console.log(this.statusObj);
      this.getList();
    },
    //异步更新
    onLoad() {
      this.getList();
    },
    //切换个人，公共
    changeActive() {
      this.statusObj = {
        label: "全部状态",
        value: "",
        labelOld: "",
        valueOld: "",
      };
      this.listQuery = {
        status: "",
        basicInfo: "",
        pageSize: 10,
        pageNumber: 1,
      };
      this.list = [];
      this.finished = false;
      this.loading = true;
      this.getList();
    },
    //抢单
    grap(item) {
      console.log(item.phone,this.form);
      requestJointOrderGrabbing({
          phone:item.phone,
          id:item.id
      })
          .then((res) => {
              if (res.data) {
                  this.$dialog
                      .confirm({
                          title: "提示",
                          message: "系统存在其他客户与该客户手机号相同，请确认是否抢单",
                          confirmButtonText: "抢单",
                          cancelButtonText: "取消",
                      })
                      .then(() => {
                        requestJointOrderCustomerGrap(item.id).then((res) => {
                                this.$toast.success("抢单成功");
                                this.active = 0;
                                this.changeActive();
                            });
                          // on confirm
                      })
                      .catch(() => {
                          // on cancel
                      });
                  resolve(true);
              }else{
                     requestJointOrderCustomerGrap(item.id).then((res) => {
                                this.$toast.success("抢单成功");
                                this.active = 0;
                                this.changeActive();
                            });
              }
          })
          .catch((err) => {
            //   this.saveLoad = false;
          });
      //  requestJointOrderPhoneRepeat(val)
      //         .then((res) => {

      //             if (res.data && res.data != this.form.id) {
      //                 this.showCity = false;
      //                 this.$dialog
      //                     .alert({
      //                         title: "提醒",
      //                         message: "系统已存在同一手机号客户",
      //                     })
      //                     .then(() => {
      //                          resolve(true);
      //                     })

      //             } else {
      //                 resolve(true);
      //             }
      //         })
      //         .catch((err) => {

      // });
    
    },
    resetQuery() {
      this.listQuery.basicInfo = "";
      this.list = [];
      this.listQuery.pageNumber = 1;
      this.finished = false;
      this.loading = true;
      this.getList();
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
.body {
  // padding-top: 0.001rem;
  font-size: 0.35rem;

  .card {
    background: #fff;
    margin: 0.3rem;
    border-radius: 0.2rem;
    // margin: 0.2rem 0;
    p {
      display: flex;
      justify-content: space-between;
      padding: 0 0.4rem;
      line-height: 1rem;
      min-height: 1rem;
      text-align: left;
      &.address {
        display: flex;
        justify-content: flex-start;
        span {
          margin-right: 0.15rem;
        }
      }
      .iconfont {
        color: $theme-color;
      }
      .go {
        color: $theme-color;
      }
    }
  }
  > .card:first-child {
    margin-top: 0;
  }
}
.fixedH {
  height: calc(100vh - 4rem);
  overflow: scroll;
}
.search {
  padding: 0.3rem;
  display: flex;
  .status {
    width: 2rem;
    padding: 0.2rem 0;
    // span {
    //   display: inline-block;
    //   width: 1.2rem;
    //   overflow: hidden;
    //   text-overflow: ellipsis;
    //   vertical-align: text-bottom;
    //   white-space: nowrap;
    // }
    .iconxiala {
      font-size: 0.2rem;
    }
  }
  .searchbar {
    flex: 1;
    padding: 0.2rem;
    background-color: #fff;
    border-radius: 0.3rem;
    position: relative;
    .left {
      position: absolute;
      left: 0.3rem;
      top: 50%;
      transform: translateY(-50%);
    }
    .right {
      position: absolute;
      right: 0.3rem;
      top: 50%;
      transform: translateY(-50%);
    }
    input {
      background: none;
      outline: none;
      border: none;
      width: calc(100% - 1.5rem);
    //   text-align: center;
      height: 0.5rem;
      line-height: 0.5rem;
    }
  }
}
// .add {
//     position: fixed;
//     width: 1.2rem;
//     height: 1.2rem;
//     line-height: 1.2rem;
//     border-radius: 2rem;
//     text-align: center;
//     bottom: 0.5rem;
//     right: 0.3rem;
//     background-color: $theme-color;
//     color: #fff;
//     i {
//         font-size: 0.7rem;
//     }
// }
.btn {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  border-radius: 0.1rem;
  overflow: hidden;
  display: flex;
  /deep/.van-button {
    margin-left: -1px;
    border: none;
    border-radius: 0;
    flex: 1;
    padding: 0%;
    &:not(:last-child)::after {
      height: 50%;
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      border-right: 0.02667rem solid #ebedf0;
      z-index: 99;
    }
  }
}
a {
  color: #666666;
}
</style>
